import PropTypes from 'prop-types';
import useDocumentTitle from '../../hooks/useDocumentTitle';

/**
 * Renders nothing but sets `document.title` to `Cleany - <title>` for the
 * lifetime of the host component. Use inside List / Create views where no
 * record is involved.
 */
const PageTitle = ({ title }) => {
  useDocumentTitle(title);
  return null;
};

PageTitle.propTypes = {
  title: PropTypes.string,
};

PageTitle.defaultProps = {
  title: undefined,
};

export default PageTitle;
